import { createContext } from 'react';
import { HistoryService } from '../../services/index.js';
class RouteContext {
    constructor(route = '', parent) {
        this.parent = parent;
        this.route = route;
    }
    get() {
        const parent = this.parent;
        const parentRoute = parent ? parent.get() : '';
        const resolved = parentRoute + this.route;
        return HistoryService.makeURL(resolved);
    }
    nestedRoute(route) {
        const parentRoute = this.get();
        return HistoryService.makeURL(parentRoute + route);
    }
    nestedContext(route) {
        return new RouteContext(route, this);
    }
}
RouteContext.Context = createContext(new RouteContext('', null));
export { RouteContext, };
//# sourceMappingURL=route-context.js.map